import { create } from 'zustand';

type ExamStore = {
  isOpenExamModal: boolean;
  setIsOpenExamModal: (isOpenExamModal: boolean) => void;
  editingTab: boolean;
  setEditingTab: (editingTab: boolean) => void;
  activeTabExercise: number;
  setActiveTabExercise: (activeTabExercise: number) => void;

  isOpenExerciseDeleteModal: boolean;
  setIsOpenExerciseDeleteModal: (isOpenExerciseDeleteModal: boolean) => void;
  exerciseToDelete: number | null;
  setExerciseToDelete: (exerciseToDelete: number | null) => void;
};

export const useExamStore = create<ExamStore>((set) => ({
  isOpenExamModal: false,
  setIsOpenExamModal: (isOpenExamModal) => set({ isOpenExamModal }),
  editingTab: false,
  setEditingTab: (editingTab) => set({ editingTab }),
  activeTabExercise: 0,
  setActiveTabExercise: (activeTabExercise) => set({ activeTabExercise }),
  isOpenExerciseDeleteModal: false,
  setIsOpenExerciseDeleteModal: (isOpenExerciseDeleteModal) =>
    set({ isOpenExerciseDeleteModal }),
  exerciseToDelete: null,
  setExerciseToDelete: (exerciseToDelete) => set({ exerciseToDelete }),
}));
